export const rentalIncomeData = [
  { month: "Jan", expected: 42000, collected: 40000 },
  { month: "Feb", expected: 42000, collected: 39500 },
  { month: "Mar", expected: 43000, collected: 41000 },
  { month: "Apr", expected: 43000, collected: 42000 },
  { month: "May", expected: 44000, collected: 43500 },
  { month: "Jun", expected: 45000, collected: 44000 },
  { month: "Jul", expected: 45000, collected: 43000 },
  { month: "Aug", expected: 45000, collected: 42000 },
  { month: "Sep", expected: 44000, collected: 41500 },
  { month: "Oct", expected: 44000, collected: 43000 },
  { month: "Nov", expected: 45000, collected: 44500 },
  { month: "Dec", expected: 46000, collected: 45500 },
];
export const occupancyData = [
  { month: "Jan", occupancy: 92 },
  { month: "Feb", occupancy: 90 },
  { month: "Mar", occupancy: 94 },
  { month: "Apr", occupancy: 96 },
  { month: "May", occupancy: 97 },
  { month: "Jun", occupancy: 95 },
  { month: "Jul", occupancy: 93 },
  { month: "Aug", occupancy: 91 },
  { month: "Sep", occupancy: 89 },
  { month: "Oct", occupancy: 92 },
  { month: "Nov", occupancy: 95 },
  { month: "Dec", occupancy: 96 },
];
